import React, { useEffect, useState } from 'react';
import { Sun, Cloud, CloudSun, CloudRain, CloudLightning, CloudFog, CloudSnow } from 'lucide-react';

// Coordenadas de Corumbá-MS
const LATITUDE = -19.0092;
const LONGITUDE = -57.6529;

const API_URL =
  `https://api.open-meteo.com/v1/forecast?latitude=${LATITUDE}&longitude=${LONGITUDE}` +
  '&daily=temperature_2m_max,temperature_2m_min,weathercode&timezone=America%2FCampo_Grande&forecast_days=2';

// Códigos WMO (usados pelo Open-Meteo) simplificados pra ícone + descrição.
function infoParaCodigo(codigo) {
  if (codigo === 0) return { Icone: Sun, texto: 'Céu limpo' };
  if ([1, 2].includes(codigo)) return { Icone: CloudSun, texto: 'Poucas nuvens' };
  if (codigo === 3) return { Icone: Cloud, texto: 'Nublado' };
  if ([45, 48].includes(codigo)) return { Icone: CloudFog, texto: 'Neblina' };
  if ([51, 53, 55, 61, 63, 65, 80, 81, 82].includes(codigo)) return { Icone: CloudRain, texto: 'Chuva' };
  if ([71, 73, 75, 77, 85, 86].includes(codigo)) return { Icone: CloudSnow, texto: 'Neve' };
  if ([95, 96, 99].includes(codigo)) return { Icone: CloudLightning, texto: 'Tempestade' };
  return { Icone: Cloud, texto: 'Sem dados' };
}

const DIAS = ['Hoje', 'Amanhã'];

const WeatherWidget = () => {
  const [dias, setDias] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let ativo = true;

    fetch(API_URL)
      .then((res) => {
        if (!res.ok) throw new Error('Falha ao buscar previsão');
        return res.json();
      })
      .then((dados) => {
        if (!ativo) return;
        const { temperature_2m_max: max, temperature_2m_min: min, weathercode: codigos } = dados.daily;
        setDias(codigos.map((codigo, i) => ({ ...infoParaCodigo(codigo), max: Math.round(max[i]), min: Math.round(min[i]) })));
      })
      .catch(() => {
        if (ativo) setErro(true);
      });

    return () => { ativo = false; };
  }, []);

  if (erro || !dias) return null; // widget discreto — some silenciosamente se a API externa falhar

  return (
    <div className="flex items-center gap-4 text-white text-sm">
      {dias.map((dia, i) => {
        const { Icone, texto, max, min } = dia;
        return (
          <div
            key={i}
            className="flex items-center gap-1.5 rounded-full px-3 py-1 shadow-md shadow-black/20"
            title={texto}
          >
            <Icone className="w-4 h-4" />
            <span className="hidden sm:inline">{DIAS[i]}</span>
            <span className="font-semibold">{max}°/{min}°</span>
          </div>
        );
      })}
    </div>
  );
};

export default WeatherWidget;
